<template>
  <div class="a-ui-tab u-margin-top-24">
    <div class="a-ui-tab__block">
      <v-collapse-wrapper :active="true">
        <div class="a-ui-tab__control-panel">
          <div class="a-ui-tab__control" v-collapse-toggle>
            <div class="a-ui-tab__arrow"></div>
            <div class="a-ui-tab__number-block">{{serial}}</div>
            <div class="a-ui-tab__title">
              {{$t('form.lot.discussion.from')}}: {{comment.author}}
            </div>
          </div>
          <date-time class="a-input a-input--disabled text-right u-margin-right-20" :value="comment.time"></date-time>
        </div>
        <div v-collapse-content>
          <div class="a-ui-tab__content-block" v-if="!editable">
            <div class="a-ui-tab__content">
              <div class="a-ui-tab__file-flex-block">
                <div class="a-flex-start-nowrap align-items-center u-margin-b-13">
                  <button class="gui-btn gui-btn--red" @click.prevent="onEditClick" v-if="comment.permissions.CAN_EDIT_DISCUSSION">{{$t('buttons.modify')}}</button>
                  <div class="a-ui-tab__file-block-number">
                  </div>
                  <p class="a-ui-tab__text">{{comment.text}}</p>
                </div>
              </div>
            </div>
            <div class="a-ui-tab__content" v-if="comment.file">
              <div class="a-ui-tab__file-flex-block">
                <div class="a-ui-tab__file-item-left">
                  <file-link :name="comment.file.name"
                             :link="externalLink(comment.file.uid)">
                  </file-link>
                </div>
              </div>
            </div>
          </div>
          <div class="a-container-form" v-if="editable">
            <div class="a-form">
              <div class="a-form__container">
                <textarea class="a-textarea " rows="3" :placeholder="$t('labels.question')" v-model="text"></textarea>

                <div class="a-form__input-file input-file--button-inline a-width-100-percent">
                  <file-link :name="file.name"
                             :size="file.size"
                             :link="externalLink(file)"
                             :removable="true"
                             :signing="false"
                             @remove="file = undefined"
                             v-if="file">
                  </file-link>

                  <file-picker :mode="file ? 'button': 'link'"
                               :signing="false"
                               @prepared="onFileSelected">
                  </file-picker>
                </div>
              </div>

              <div class="a-form__submit">
                <button class="gui-btn gui-btn--red gui-btn--w-184" @click.prevent="onSaveClick">{{$t('buttons.save')}}</button>
                <button class="gui-btn gui-btn--red gui-btn--w-184" @click.prevent="editable = false">{{$t('buttons.cancel')}}</button>
              </div>
            </div>
          </div>
        </div>
      </v-collapse-wrapper>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      lot: Object,
      serial: Number,
      comment: Object
    },

    data: () => ({
      editable: false,

      text: undefined,
      file: undefined
    }),

    methods: {
      onEditClick() {
        this.text = this.comment.text;
        this.file = this.comment.file;

        this.editable = true;
      },

      onFileSelected(file) {
        this.file = file;
      },

      async onSaveClick() {
        this.runBlockerAction(async() => {
          try {
            await this.$store.dispatch('updateLotComment', {
              lotId: this.lot.id,
              commentId: this.comment.id,
              text: this.text,
              file: this.file
            });

            this.editable = false;
            this.file = undefined;
            this.text = undefined;
          }
          catch(e) {
            console.error('failed sending question', e);
            this.globalErrorHandler(e);
          }
        });
      },
    }
  }
</script>

<style scoped>

</style>
